var publicPath = __webpack_public_path__;
            var symbolUrl = 'img/sprite.3d7967c1.svg#icon-close';
            var viewUrl = 'img/sprite.3d7967c1.svg#view-icon-close';

            

            module.exports = {
                symbol: publicPath + symbolUrl,
                view: publicPath + viewUrl,
                viewBox: '0 0 27 27',
                title: 'close',
                toString: function () {
                    return JSON.stringify(this.view);
                }
            };